<!-- HEADER START -->
<ng-container *ngIf="booking$ | async as booking"> 

<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title color="secondary" [ngClass]="{'canceled': booking.canceled}" class="ion-text-center header-title">#{{ booking.id }}</ion-title>
      <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/moj-profil', 'moje-rezervacije']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>

      <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>
<!-- HEADER END -->
  
<ion-content>
  <ion-grid fixed class="ion-no-padding">
  <ion-item lines="none" class="bookings--reserved__item active">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-align-items-start">

        <ion-col size="12" >

          <div *ngIf="booking.status == 10">
            <ion-badge color="warning" style="border-radius:0;" class="ion-float-left">{{ 'BOOKING_DETAIL.CONFIRMATION_PENDING' | translate }}</ion-badge>
          </div>

          <div *ngIf="booking.status == 20">
            <ion-badge color="success" style="border-radius:0;" class="ion-float-left">{{ 'BOOKING_DETAIL.CONFIRMED' | translate }}</ion-badge>
          </div>
       
          <div *ngIf="booking.paymentRequired && !booking.paid && !booking.canceled">
            <ion-badge color="danger" style="border-radius:0;">{{ 'BOOKING_DETAIL.PAYMENT_MISSING' | translate }}</ion-badge>
            <p>{{ 'BOOKING_DETAIL.PAYMENT_MISSING_DESCRIPTION' | translate }}</p>
            <ion-button color="primary" (click)="pay(booking)" expand="full" class="btn--large ion-no-margin">{{ 'BOOKING_DETAIL.PAY_NOW' | translate }}</ion-button>

          </div>

          <div *ngIf="booking.noShowProtection && !booking.noShowProtected && !booking.canceled">
            <ion-badge color="danger" style="border-radius:0;">{{ 'BOOKING_DETAIL.NO_SHOW_PROTECTION_MISSING' | translate }}</ion-badge>
            <p>{{ 'BOOKING_DETAIL.NO_SHOW_PROTECTION_MISSING_DESCRIPTION' | translate }}</p>
            <ion-button color="primary" (click)="pay(booking)" expand="full" class="btn--large ion-no-margin">{{ 'BOOKING_DETAIL.SAVE_CARD_NOW' | translate }}</ion-button>

          </div>

          <div *ngIf="booking.paymentRequired && booking.paid">
            <ion-badge color="success" style="border-radius:0;" class="ion-float-left">{{ 'BOOKING_DETAIL.PAID' | translate }}</ion-badge>
          </div>

        </ion-col>

       </ion-row>

      <ion-row class="ion-align-items-start">
        <ion-col size="8" style="margin-bottom:2px;">
          <div class="finalize-appointment">

            <p *ngIf="booking?.onBehalfOfName">{{booking.onBehalfOfName}}</p>
            <p *ngIf="booking?.onBehalfOfPhone">{{booking.onBehalfOfPhone}}</p>
            <p *ngIf="booking?.onBehalfOfEmail">{{booking.onBehalfOfEmail}}</p>


            <h5>{{ 'BOOKING_DETAIL.LOCATION' | translate }}:</h5>
            <p class="bookings--reserved__item-shop">{{ booking.getShopName() }}</p>
            <p class="bookings--reserved__item-address">{{ booking.getRootReal().address }}</p>
            <a class="pp-link" [routerLink]="['./zemljevid']">{{ 'BOOKING_DETAIL.MAP' | translate }}</a>

            <h5 style="margin-top:36px;">{{ 'BOOKING_DETAIL.PICKED_SLOT' | translate }}</h5>
            <p [ngClass]="{'canceled': booking.canceled}" class="bookings--reserved__item-date">{{ booking.start | momentDate:"fullDate":undefined:translateService.currentLang | titlecase }}</p>
            <p [ngClass]="{'canceled': booking.canceled}" class="bookings--reserved__item-time">{{ 'BOOKING_DETAIL.START_AT' | translate }} <span class="bold">{{ booking.start | momentDate:"shortTime":undefined:translateService.currentLang }}</span></p>
            <p [ngClass]="{'canceled': booking.canceled}" class="bookings--reserved__item-time"><span class="bold">{{ 'BOOKING_DETAIL.FOR' | translate }} {{ booking.partySize}} {{ booking.partySize | i18nPlural : { '=1': 'PERSON_PLURAL.PERSON_1', '=2': 'PERSON_PLURAL.PERSONS_2', '=3': 'PERSON_PLURAL.PERSONS_3', '=4': 'PERSON_PLURAL.PERSONS_4', 'other': 'PERSON_PLURAL.PERSONS_5'} | translate }}</span></p>
            <a *ngIf="doWeShowCancelationOption(booking)" class="clickable pp-link" (click)="cancelBooking(booking, translateService.currentLang)" >{{ 'BOOKING_DETAIL.CANCEL' | translate }}</a>

            <p *ngIf="booking.paid">{{ 'BOOKING_DETAIL.CANCEL_PAID_INFO' | translate }}</p>

            <ion-badge *ngIf="booking.canceled" class="ion-margin-top" color="primary">{{ 'BOOKING_DETAIL.CANCELED' | translate }}</ion-badge>

          </div>
        </ion-col>
        <ion-col size="4">
            <div class="ion-float-right">
          <!--<ion-button class="btn--default ion-margin-top ion-float-right" [routerLink]="['./zemljevid']">Zemljevid&nbsp;<ion-icon name="map-sharp" class="earth"></ion-icon></ion-button><br>-->
            <ion-img style="max-width: 100px; margin-top: 26px" class="ion-padding-top" [src]="( booking.getShopImage() | ppImage )"></ion-img>

            <div  style="max-width: 100px; margin-top: 26px">
              <qr-code [padding]="0" [value]="'https://manager.table42.app/' + booking.provider.slug + '/rezervacije/' + booking.id" [size]="100"></qr-code>
            </div>

          </div>

        </ion-col>  
        
      </ion-row>
    </ion-grid>
  </ion-item>

  <ion-list style="margin-top:40px;">

  <ng-container *ngIf="booking.minSpend">

  <ion-item *ngIf="booking.paymentAmount" color="none" lines="none" class="finalize-appointment__item finalize-appointment__item--total">
      <ion-grid  class="ion-no-padding">
        <ion-row class="ion-align-items-center ion-no-padding">
          <ion-col size="10" class="col--main">
            <span>{{ 'BOOKING_DETAIL.MIN_SPEND_AMOUNT' | translate }}</span>
          </ion-col>
          <!--ion-col size="3"></ion-col-->


          <ion-col size="2" class="ion-text-end">{{ booking.paymentAmount | currency: booking.total.currency  }}</ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

  </ng-container>

  <ng-container *ngIf="!booking.minSpend">
    

    <ion-item color="none" lines="none" class="finalize-appointment__item" *ngFor="let bp of booking.bookingProducts; index as i;">


      <ion-grid  class="ion-no-padding" *ngIf="bp.service as s">
        
        <!--ion-row class="ion-no-padding ion-align-items-center">
          <ion-col size="8" class="finalize-appointment__item-lead">{{ s.name }}</ion-col>
          <ion-col size="2"></ion-col>
          <ion-col size="2"></ion-col>
        </ion-row-->
        <ion-row class="ion-align-items-center ion-no-padding" >
          <ion-col size="6" class="col--main">
            <div class="img-container">
              <img style="max-height: 30px" [src]= "s.avatar?.document?.fileName | ppImage">
            </div>
            <span>{{ s.name | ppTranslate:s.nameTranslations:translateService.currentLang }}</span>
          </ion-col>
          <ion-col size="2">{{ bp.quantity }} x</ion-col>
          <ion-col size="2">{{ bp.price.amount | currency: bp.price.currency }}</ion-col>
          <ion-col size="2" class="ion-text-end">{{ (bp.price.amount * bp.quantity)  | currency: bp.price.currency }}</ion-col>
        </ion-row>


       <ion-row><pre></pre></ion-row>
      </ion-grid>

    </ion-item>


    <ion-item *ngIf="booking.total" color="none" lines="none" class="finalize-appointment__item finalize-appointment__item--total">
      <ion-grid  class="ion-no-padding">
        <ion-row class="ion-align-items-center ion-no-padding">
          <ion-col size="10" class="col--main">
            <span>{{ 'BOOKING_DETAIL.TOTAL' | translate }}</span>
          </ion-col>
          <!--ion-col size="3"></ion-col-->


          <ion-col size="2" class="ion-text-end">{{ booking.total.amount | currency: booking.total.currency  }}</ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

  </ng-container>

  </ion-list>


  <div *ngIf="booking.customerNotes" class="ion-padding" >
    <p class="text-normal--small">{{ 'BOOKING_DETAIL.NOTES' | translate }}: {{ booking.customerNotes }}</p>
  </div>


  </ion-grid>
</ion-content>
</ng-container>